// src/composables/useImageConverter.ts
import { ref } from "vue";

/** NEW MODAL */
import { createModal } from "@/services/modalService";
export function useModal() {
  //user
  const modalAddUser = createModal("modal_add_user");
  const modalResetPassword = createModal("modal_reset_password");
  const modalAffectedToClub = createModal("modal_affected_to_club");

  const modalAddOrder = createModal("modal_browser");
  const modalEditMember = createModal("modal_edit_member");
  const modalAttachedPointeuses = createModal(
    "modal_attched_pointeuses_member",
  );

  const modalAssurancePayment = createModal("modal_member_assurance_payment");


  const modalAddIncome = createModal("modal_add_income");
  const modalReglerIncome = createModal("modal_add_payment_service");
  const modalTransactionsIncome = createModal("modal_details_income");
  const modalRegulationsStatsIncome = createModal("modal_regulations_income");

  const modalAddExpense = createModal("modal_add_expense");
  const modalReglerExpense = createModal("modal_add_payment_expense");
  const modalTransactionsExpense = createModal("modal_details_expense");
  const modalRegulationsStatsExpense = createModal("modal_regulations_expense");

  const modalAddAnnouncement = createModal("modal_add_announcement");
  const modalAddPromotion = createModal("modal_add_promotion");
  const modalAddBilan = createModal("modal_add_bilan");
  const modalAddSessionBooking = createModal("modal_add_session_booking");

  const modalTransactionsStats = createModal("modal_transactions_stats");
  const modalSubscriptionStats = createModal("modal_subscription_stats");
  const modalChangeStatusPayment = createModal("modal_change_status_payement");

  /**Trainers */
  const modalAddTrainer = createModal("modal_add_trainer");
 
  const modalReglerTrainer = createModal("modal_regler_trainer");
  const modalTransactionsTrainer = createModal("modal_transactions_trainer");
  const modalRegulationsStatsTrainer = createModal("modal_regulations_trainer");

 
 
  const openModal = (id, action, order) => {
    if (action == "add") {
      if (id == "modal_change_status_payement") {
        modalChangeStatusPayment?.show();
      }

      if (id == "modal_browser") {
        modalAddOrder?.show();
      }

      if (id == "modal_add_trainer") {
        modalAddTrainer?.show();
      }
       
      if (id == "modal_regler_trainer") {
        modalReglerTrainer?.show();
      }
 
     
      if (id == "modal_member_assurance_payment") {
        modalAssurancePayment?.show();
      }
         if (id == "modal_add_income") {
           modalAddIncome?.show();
         }

      if (id == "modal_add_payment_service") {
        modalReglerIncome?.show();
      }

      if (id == "modal_add_expense") {
        modalAddExpense?.show();
      }

      if (id == "modal_add_payment_expense") {
        modalReglerExpense?.show();
      }

      if (id == "modal_add_user") {
        modalAddUser?.show();
      }
      if (id == "modal_reset_password") {
        modalResetPassword?.show();
      }
      if (id == "modal_affected_to_club") {
        modalAffectedToClub?.show();
      }

      if (id == "modal_add_announcement") {
        modalAddAnnouncement?.show();
      }
      if (id == "modal_add_promotion") {
        modalAddPromotion?.show();
      }
      if (id == "modal_add_bilan") {
        modalAddBilan?.show();
      }
       if (id == "modal_add_session_booking") {
         modalAddSessionBooking?.show();
       }
    }

    if (action == "edit") {
      if (id == "modal_attched_pointeuses_member") {
        modalAttachedPointeuses?.show();
      }
      if (id == "modal_edit_member") {
        modalEditMember?.show();
      }
      // change this
      if (id == "modal_edit_user") {
        modalAddUser?.show();
      }

      if (id == "modal_edit_announcement") {
        modalAddAnnouncement?.show();
      }
      if (id == "modal_add_promotion") {
        modalAddPromotion?.show();
      }
      if (id == "modal_add_bilan") {
        modalAddBilan?.show();
      }
      if (id == "modal_add_session_booking") {
        modalAddSessionBooking?.show();
      }
    }
    if (action == "view") {
      if (id == "modal_details_income") {
        modalTransactionsIncome?.show();
      }
      if (id == "modal_transactions_stats") {
        modalTransactionsStats?.show();
      }
      if (id == "modal_subscription_stats") {
        modalSubscriptionStats?.show();
      }

      if (id == "modal_details_expense") {
        modalTransactionsExpense?.show();
      }

      if (id == "modal_regulations_income") {
        modalRegulationsStatsIncome?.show();
      }
      if (id == "modal_regulations_expense") {
        modalRegulationsStatsExpense?.show();
      }
    }
  };
  const closeModal = (id, action) => {
    if (action == "add") {
      if (id == "modal_change_status_payement") {
        modalChangeStatusPayment?.hide();
      }
      if (id == "modal_browser") {
        modalAddOrder?.hide();
      }

      if (id == "modal_add_trainer") {
        modalAddTrainer?.hide();
      }
  

      if (id == "modal_regler_trainer") {
        modalReglerTrainer?.hide();
      }
 
      if (id == "modal_add_income") {
        modalAddIncome?.hide();
      }
       
      if (id == "modal_member_assurance_payment") {
        modalAssurancePayment?.hide();
      }
      if (id == "modal_add_payment_service") {
        modalReglerIncome?.hide();
      }

      if (id == "modal_add_expense") {
        modalAddExpense?.hide();
      }

      if (id == "modal_add_payment_expense") {
        modalReglerExpense?.hide();
      }
      if (id == "modal_add_user") {
        modalAddUser?.hide();
      }
      if (id == "modal_reset_password") {
        modalResetPassword?.hide();
      }
      if (id == "modal_affected_to_club") {
        modalAffectedToClub?.hide();
      }
      if (id == "modal_add_announcement") {
        modalAddAnnouncement?.hide();
      }
      if (id == "modal_add_promotion") {
        modalAddPromotion?.hide();
      }
      if (id == "modal_add_bilan") {
        modalAddBilan?.hide();
      }
      if (id == "modal_add_session_booking") {
        modalAddSessionBooking?.hide();
      }
    }

    if (action == "edit") {
      if (id == "modal_attched_pointeuses_member") {
        modalAttachedPointeuses?.hide();
      }
      if (id == "modal_edit_member") {
        modalEditMember?.hide();
      }
      //change this
      if (id == "modal_edit_user") {
        modalAddUser?.hide();
      }

      if (id == "modal_edit_announcement") {
        modalAddAnnouncement?.hide();
      }
      if (id == "modal_add_promotion") {
        modalAddPromotion?.hide();
      }
      if (id == "modal_add_bilan") {
        modalAddBilan?.hide();
      }
       if (id == "modal_add_session_booking") {
         modalAddSessionBooking?.hide();
       }
    }
    if (action == "view") {
      if (id == "modal_details_income") {
        modalTransactionsIncome?.hide();
      }
      if (id == "modal_transactions_stats") {
        modalTransactionsStats?.hide();
      }
      if (id == "modal_subscription_stats") {
        modalSubscriptionStats?.hide();
      }
      if (id == "modal_details_expense") {
        modalTransactionsExpense?.hide();
      }
      if (id == "modal_regulations_income") {
        modalRegulationsStatsIncome?.hide();
      }
      if (id == "modal_regulations_expense") {
        modalRegulationsStatsExpense?.hide();
      }
    }
  };

  return {
    closeModal,
    openModal,
  };
}
